var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 4.9C12.5933 4.9 13.1734 5.07595 13.6667 5.40559C14.1601 5.73524 14.5446 6.20377 14.7716 6.75195C14.9987 7.30013 15.0581 7.90333 14.9424 8.48527C14.8266 9.06721 14.5409 9.60176 14.1213 10.0213C13.7018 10.4409 13.1672 10.7266 12.5853 10.8424C12.0033 10.9581 11.4001 10.8987 10.8519 10.6716C10.3038 10.4446 9.83524 10.0601 9.50559 9.56671C9.17595 9.07336 9 8.49334 9 7.9C9 7.10435 9.31607 6.34129 9.87868 5.77868C10.4413 5.21607 11.2044 4.9 12 4.9ZM12 12.8C14 12.8 18 13.89 18 15.88C17.3432 16.8701 16.4516 17.6823 15.4047 18.2442C14.3578 18.806 13.1881 19.1 12 19.1C10.8119 19.1 9.64218 18.806 8.59527 18.2442C7.54836 17.6823 6.65677 16.8701 6 15.88C6 13.89 10 12.8 12 12.8Z",
    fill: "#1B3E61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.77dc8759d31e6c683ab10293b24f5e30.svg";
export { ForwardRef as ReactComponent };